import React from 'react';

import { Modal, Tabs } from 'antd/lib';
import { graphql, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';

import getTraspasoPorId from '../../../graphql/querys/rrhh/getTraspasoPorId.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import VerStock from '../../admGeneral/stock/VerStock';
import DatosEntrega from './tabs/DatosEntrega';
import DatosRecepcion from './tabs/DatosRecepcion';

const TabPane = Tabs.TabPane;

@graphql(getUsuario)
class ConfirmarTraspaso extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      filtro: '',
      traspaso: {},
    };

    this.props.client
      .query({
        query: getTraspasoPorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(res => {
        let traspaso = res.data.getTraspasoPorId;
        if (traspaso) {
          this.setState({
            ...this.state,
            loading: false,
            traspaso: traspaso,
          });
        }
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);

        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    if (
      (this.state.traspaso && this.state.traspaso.estado != 'PENDIENTE') ||
      this.props.usuario._id != this.state.traspaso.usuarioEntrante._id
    ) {
      this.props.history.push('/rrhh/traspasos');
    }

    return (
      <Tabs defaultActiveKey="entrega">
        <TabPane tab="Datos entrega" key="entrega">
          <DatosEntrega traspaso={this.state.traspaso} />
        </TabPane>
        <TabPane tab="Stock Actual" key="stock">
          <VerStock />
        </TabPane>
        <TabPane tab="Datos recepcion" key="recepcion">
          <DatosRecepcion
            traspaso={this.state.traspaso}
            history={this.props.history}
          />
        </TabPane>
      </Tabs>
    );
  }
}

export default withApollo(ConfirmarTraspaso);
